import styleInject from '../../external/style-inject/dist/style-inject.es.js';

var css_248z = ".ButtonSkeleton-module_button__c4oqU {\n  display: block;\n  width: 280px;\n  height: 40px;\n  border-radius: 32px;\n  background-color: #f5f6f8;\n}\n@media (min-width: 1000px) {\n  .ButtonSkeleton-module_button__c4oqU {\n    width: 150px;\n  }\n}";
var styles = {"button":"ButtonSkeleton-module_button__c4oqU"};
styleInject(css_248z);

export { styles as default };
